"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optional = exports.multi = exports.named = exports.withDependencies = exports.InversifyContainer = exports.Container = void 0;
const tslib_1 = require("tslib");
var simple_container_1 = require("./ioc/simple-container");
Object.defineProperty(exports, "Container", { enumerable: true, get: function () { return simple_container_1.Container; } });
var inversify_1 = require("./ioc/inversify");
Object.defineProperty(exports, "InversifyContainer", { enumerable: true, get: function () { return inversify_1.Container; } });
var metadata_1 = require("./ioc/metadata");
Object.defineProperty(exports, "withDependencies", { enumerable: true, get: function () { return metadata_1.withDependencies; } });
Object.defineProperty(exports, "named", { enumerable: true, get: function () { return metadata_1.named; } });
Object.defineProperty(exports, "multi", { enumerable: true, get: function () { return metadata_1.multi; } });
Object.defineProperty(exports, "optional", { enumerable: true, get: function () { return metadata_1.optional; } });
tslib_1.__exportStar(require("./ioc/symbols"), exports);
tslib_1.__exportStar(require("./ioc/types"), exports);
//# sourceMappingURL=index.js.map